$(document).ready(function () {  

//checkbox text field
  $("#chk-box").click(function () {
            if ($(this).is(":checked")) {
                $("#note1").show();
            } else {
                $("#note1").hide();
            }
        });

  $("#short-note1").click(function () {
            if ($(this).is(":checked")) {
                $("#note11").show();
            } else {
                $("#note11").hide();
            }
        });

// number validation
  $(function () {
        $("#txtNumber").keypress(function (e) {
            var keyCode = e.keyCode || e.which;
            $("#lblError").html("");
            var regex = /^[0-9]+$/;
            var isValid = regex.test(String.fromCharCode(keyCode));
            if (!isValid) {
                $("#lblError").html("number only for phone number.");
            }
            return isValid;
        });
    }); 
// 2 numeric 
       $("#txtNumber").bind("keypress", function (e) {
                var keyCode = e.which ? e.which : e.keyCode
                if (!(keyCode >= 48 && keyCode <= 57)) {
                    $(".error").css("display", "inline");
                    return false;
                } else {
                    $(".error").css("display", "none");
                }
            });
//chkbox
  $("#Vendredi").click(function () {
            if ($(this).is(":checked")) {
                $("#chk-third").show();
            } else {
                $("#chk-third").hide();
            }
        }); 
  $("#Jeudi").click(function () {
            if ($(this).is(":checked")) {
                $("#chk-second").show();
            } else {
                $("#chk-second").hide();
            }
        }); 
  $("#Mercredi").click(function () {
            if ($(this).is(":checked")) {
                $("#chk-first").show();
            } else {
                $("#chk-first").hide();
            }
        });
  
// $(document).on("click" , '.label', function(){
//   $(this).addClass('active').siblings().removeClass('active');
//   //$('.radio-content').addClass('active').parents('.form-group').find('.radio-content').removeClass('active');
// });
  
 // $('.checkpoint').click(function() {
 //        $('.checkpoint').not(this).prop('checked', false);
 //                $(".radio-content").addClass('active').siblings().removeClass('active');
 //            } 
         
   
 //    });

// $('.checked').click(function() {
//         $('.checked').not(this).prop('checked', false);
  
// });

   $("input[type='radio']").change(function() {
                if ($(this).val() == "other") {
                    $("#otherAnswer").show();
                } else {
                    $("#otherAnswer").hide();
                }
            });




   // $(function() {
   //      $("#date").datepicker({ 
   //          dateFormat: 'DD/MM/YY' 
   //      });
   //  });
  
});


$(".onlyNumber").bind("keypress", function (e) {
    var keyCode = e.which ? e.which : e.keyCode
    if (!(keyCode >= 48 && keyCode <= 57)) {
        $(".error").css("display", "inline");
        return false;
    } else {
        $(".error").css("display", "none");
    }
});
$("#cart-gift .form-check input[type='radio']").click(function() {
    var giftChoice = $(this).val();
    if(giftChoice == 'yes' || giftChoice == 'Yes'){
      $('.giftForm').slideDown();
      $('.checkValidation').show();
      $('.checkoutBTN').hide();
    }
    else{
      
      $('.giftForm').slideUp();
      $(".giftForm input").val("");
      $(".giftForm textarea").val("");

      setTimeout(function () {
        $.ajax({
          type: 'POST',
          url: '/cart/update.js',
          data: {
            attributes: {
              'Est-ce que cet abonnement est un cadeau?':'',
              'Prénom': '‎ ',
              'Nom': '‎ ',
              'Nom de société': '‎ ',
              'Email': '‎ ',
              'Téléphone': '‎ ',
              'Mots pour votre destinataire pour la première envoient':'‎ ',
            }
          },
          dataType: 'json',
          success: function(cart) {
            $('.checkValidation').hide();
            $('.checkoutBTN').show();
            console.log('Cart updated successfully:', cart);
          },
          error: function(XMLHttpRequest, textStatus, errorThrown) {
            console.error('Error updating cart:', textStatus, errorThrown);
          }
        });
      }, 1000);
      
    }
});

$(document).ready(function(){
  var currentDate = new Date().toISOString().split('T')[0];
  document.getElementById('date').min = currentDate;
})
$(document).ready(function(){
  var currentDate = new Date().toISOString().split('T')[0];
  document.getElementById('subject').min = currentDate;
})

$(document).ready(function(){
// $('body').on('click', '.checkValidation', function(e){
//   e.preventDefault();
//   if (!validateRequiredFields()) {
  
//   } else {
    
//     $('.checkValidation').hide();
//     $('.checkoutBTN').show();
//     $('.checkoutBTN').click();
//   }
// });

// function validateRequiredFields() {
//     var isValid = true;
//     $('.giftForm input, .giftForm textarea').each(function() {
//       if ($(this).val().trim() === '') {
//         var validClass = $(this).attr('data-count');
//         $('.count-'+validClass).html('This field is required.');
//         isValid = false;
//         $(this).addClass('error-field');
//       } else {
//         var validClass = $(this).attr('data-count');
//         $(this).removeClass('error-field');
//         $('.count-'+validClass).html('');
//       }
//     });
//     $('.cart-button-checkout-spinner').addClass('hide');
//     $('.cart-button-checkout-text').removeClass('hide');
//     return isValid;
//   }



   $('body').on('click', '.checkValidation', function(e) {
     
        e.preventDefault();
        if (!validateRequiredFields()) {
          // Do something if validation fails
        } else {
          $('.checkValidation').hide();
          $('.checkoutBTN').show();
          $('.checkoutBTN').click();
        }
      });
  

      function validateRequiredFields() {
        var isValid = true;

        // Loop through each input element with the "giftForm" class
        $('#cartSlideoutWrapper .giftForm input,#cartSlideoutWrapper .giftForm textarea').each(function() {
          var inputVal = $(this).val().trim();
          var validClass = $(this).attr('data-count');
          var inputId = $(this).attr('id');
         
          if (inputVal === '' && inputId != 'nom-de-societe') {
            var validClass = $(this).attr('data-count');
            $('.count-' + validClass).html('This field is required.');
            isValid = false;
            $(this).addClass('error-field');
          } else {
            var validClass = $(this).attr('data-count');
            $(this).removeClass('error-field');
            $('.count-' + validClass).html('');
          }

          // Check email format if the field has the type "email"
          if ($(this).attr('type') === 'email' && inputVal !== '') {
            if (!isValidEmail(inputVal)) {
              var validClass = $(this).attr('data-count');
              $('.count-' + validClass).html('Please enter a valid email address.');
              isValid = false;
              $(this).addClass('error-field');
            } else {
              var validClass = $(this).attr('data-count');
              $(this).removeClass('error-field');
              $('.count-' + validClass).html('');
            }
          }
        });

        $('.cart-button-checkout-spinner').addClass('hide');
        $('.cart-button-checkout-text').removeClass('hide');

        return isValid;
      }

      function isValidEmail(email) {
        var emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailPattern.test(email);
      }
    });



function isValidEmail(email) {
  var emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailPattern.test(email);
}

$('.email').change(function() {
  var emailValue = $(this).val().trim();
  var validClass = $(this).attr('data-count');
  if (emailValue !== '' && !isValidEmail(emailValue)) {
    $('.count-'+validClass).html('please enter valid email address');
    $(this).addClass('error-field');
  } else {
    $('.count-'+validClass).html('');
    $(this).removeClass('error-field');
  }
});



$('body').on('click', '.checkValidationNew', function(e) {

  e.preventDefault();
        // if (!validateRequiredFieldsNew()) {
          // Do something if validation fails
        // } else {
          // $(this).hide();
          // $(this).parents('#myModal').find('.shopify-payment-button__button[data-testid="Checkout-button"]').show();
          $(this).parents('#myModal').find('.shopify-payment-button__more-options[data-testid="sheet-open-button"]').click();
        // }
      });



// $('body').on('click', '.checkValidationNew.no-selected', function(e) {
//         e.preventDefault();
//           // $(this).hide();
//           // $(this).parents('#myModal').find('.shopify-payment-button__button[data-testid="Checkout-button"]').show();
//          $(this).parents('#myModal').find('.shopify-payment-button__more-options[data-testid="sheet-open-button"]').click();
//   });



      function validateRequiredFieldsNew() {
        var isValid = true;
        // Loop through each input element with the "giftForm" class
        $('.jtplCurrentForm .modal .giftForm input,.jtplCurrentForm .modal .giftForm textarea').each(function() {
          var inputVal = $(this).val().trim();
          var validClass = $(this).attr('data-count');
          var inputId = $(this).attr('id');
          
          if (inputVal === '' && inputId != 'nom-de-societe') {
            var validClass = $(this).attr('data-count');
            $('.count-' + validClass).html('This field is required.');
            isValid = false;
            $(this).addClass('error-field');
          } else {
            var validClass = $(this).attr('data-count');
            $(this).removeClass('error-field');
            $('.count-' + validClass).html('');
          }

          // Check email format if the field has the type "email"
          if ($(this).attr('type') === 'email' && inputVal !== '') {
            if (!isValidEmail(inputVal)) {
              var validClass = $(this).attr('data-count');
              $('.count-' + validClass).html('Please enter a valid email address.');
              isValid = false;
              $(this).addClass('error-field');
            } else {
              var validClass = $(this).attr('data-count');
              $(this).removeClass('error-field');
              $('.count-' + validClass).html('');
            }
          }
        });

        $('.cart-button-checkout-spinner').addClass('hide');
        $('.cart-button-checkout-text').removeClass('hide');

        return isValid;
      }

$("#myModal .form-check").click(function() {
    $(this).find('input').prop("checked", true);
    var giftChoice = $(this).find('input').val();

    if(giftChoice == 'yes' || giftChoice == 'Yes'){
       $('form').removeClass('jtplCurrentForm');
        var form = $(this).closest("form");
        form.addClass("jtplCurrentForm");
      
      $(this).parents('#myModal').find('.giftForm').slideDown();
      // $('.checkValidation').show();
      // $('.checkoutBTN').hide();
       $('.checkValidationNew').addClass('yes-selected');
       $('.checkValidationNew').removeClass('no-selected');
    }
    else{ 
      $(this).parents('#myModal').find('.giftForm').slideUp();
      $('.modal .giftForm input').val('');
      $('.modal .giftForm textarea').val('');
      // $('.giftForm').slideUp();
      // $(".giftForm input").val("");
      // $(".giftForm textarea").val("");  
      $('.checkValidationNew').addClass('no-selected');
      $('.checkValidationNew').removeClass('yes-selected');
    }
});





$(document).on('click','.shopify-payment-button__button-cstm',function(){
 $('.form-check-input[value="Yes"]').prop("checked", false);
  $('.form-group small').html('');
  $(this).parents('form').find('.modal').css('display','block');
});

$('body').on('click','.close',function(){
  $('.modal').find('.giftForm').slideUp();
  $(this).parents('form').find('.modal').css('display','none');
});

if($('html').attr('lang') == 'fr'){
    $('.shopify-payment-button__button-cstm').text('Acheter maintenant');
} else {
    $('.shopify-payment-button__button-cstm').text('Buy Now');
}
